module.exports = __webpack_public_path__ + "static/media/designsprint2.16ace134.jpg";